export default {
  title: 'Ontvang nieuws en aanbiedingen via e-mail',
  form: {
    marketing_subscription: {
      label: 'Ontvang exclusieve aanbiedingen, kortingen en updates direct in je inbox',
    },
  },
};
